<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7 17.5H5.25C4.56 17.5 4 16.94 4 16.25V6.75C4 6.06 4.56 5.5 5.25 5.5H18.75C19.44 5.5 20 6.06 20 6.75V16.25C20 16.94 19.44 17.5 18.75 17.5H11.5L8.25 20V18.75C8.25 18.06 7.69 17.5 7 17.5Z"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 10H16"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
    />
    <path
      d="M8 13.25H13.5"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
    />
  </svg>
</template>
